import * as processOrdersConstant from './constants'

export const processOrdersCheckedListRequest = function processOrdersCheckedListRequest(formData, callback) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_CHECKED_LIST_REQUESTING,
    payload: formData,
    callback
  }
}

export const processOrdersListNvRequest = function processOrdersListNvRequest(formData, callback) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_LIST_NV_REQUESTING,
    formData,
    callback
  }
}

export const processOrdersListNvSuccess = function processOrdersListNvSuccess(data) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_LIST_NV_SUCCESS,
    data
  }
}

export const processOrdersListNvError = function processOrdersListNvError(error) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_LIST_NV_ERROR,
    error
  }
}

export const processOrdersListRequest = function processOrdersListRequest(formData) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_LIST_REQUESTING,
    formData
  }
}

export const processOrdersListSuccess = function processOrdersListSuccess(data) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_LIST_SUCCESS,
    data
  }
}

export const processOrdersListError = function processOrdersListError(error) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_LIST_ERROR,
    error
  }
}

export const processOrdersKhachHangRequest = (formData) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_KHACHHANG_REQUESTING,
    payload: formData
  }
}

export const processOrdersKhachHangSuccess = function processOrdersKhachHangSuccess(data) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_KHACHHANG_SUCCESS,
    data
  }
}

export const processOrdersKhachHangError = function processOrdersKhachHangError(error) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_KHACHHANG_ERROR,
    error
  }
}
export const processOrdersDaiLyRequest = function processOrdersDaiLyRequest(formData) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_DAILY_REQUESTING,
    formData
  }
}

export const processOrdersDaiLySuccess = function processOrdersDaiLySuccess(data) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_DAILY_SUCCESS,
    data
  }
}

export const processOrdersDaiLyError = function processOrdersDaiLyError(error) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_DAILY_ERROR,
    error
  }
}

export const processOrdersExportXlsRequest = (formData, onSuccess) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_EXPORT_XLS_REQUESTING,
    payload: formData,
    onSuccess
  }
}

export const processOrdersExportXlsSuccess = () => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_EXPORT_XLS_SUCCESS,
  }
}

export const processOrdersExportXlsError = function processOrdersExportXlsError(error) {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_EXPORT_XLS_ERROR,
    error
  }
}

export const setProcessMessage = (msg) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_SET_APPROVE_MESSAGE,
    payload: msg
  }
}
export const setProcessError = (error) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_SET_APPROVE_ERROR,
    payload: error
  }
}

export const setIsLoading = (isLoading) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_SET_IS_LOADING,
    payload: isLoading,
  }
}
export const setTypeOrder = (data) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_SET_TYPEOF_ORDER,
    payload: data,
  }
}
export const setOrderId = (data) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_SET_ORDER_ID,
    payload: data,
  }
}
export const setMode = (mode) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_SET_MODE_FORM,
    payload: mode
  }
}
export const getOrderDetails = (payload, callback) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_LOAD_ORDER_DETAILS,
    payload,
    callback
  }
}
export const processOrderDeleteOrder = (formData, callback) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_DELETE_ORDER,
    payload: formData,
    callback
  }
}
export const processOrderCreate = (formData, callback) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_CREATE_ORDER_REQUESTING,
    payload: formData,
    callback
  }
}
export const processOrderConfirm = (formData, callback) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_CONFIRM_REQUESTING,
    payload: formData,
    callback
  }
}
export const setCallbackFunc = (callback) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_SET_CALLBACK_FUNC,
    payload: callback
  }
}
export const loadOrderExport = (data, callback) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_LOAD_ORDER_EXPORT,
    payload: data,
    callback
  }
}
export const loadOrderExcel = (requestData, callback) => {
  return {
    type: processOrdersConstant.PROCESS_ORDERS_LOAD_ORDER_EXCEL,
    payload: requestData,
    callback
  }
}


// WEBPACK FOOTER //
// ./src/views/ProcessOrders/actions.js